import React from 'react'

function FooterProfilesList() {
  return (
    <div>
      <ul className="profiles">
        <li className="profiles__title header-list">Profiles</li>
        <li className="profiles__li">
          <a href="github.com">@ray-bang8</a>
        </li>
        <li className="profiles__li">
          <a href="github.com">@elygo</a>
        </li>
        <li className="profiles__li">
          <a href="github.com">@shamshodisayev</a>
        </li>
      </ul>
    </div>
  )
}

export default FooterProfilesList
